<template>
  <div>
    <el-upload
      :auto-upload="false"
      :on-remove="remove"
      :on-change="onChange"
      class="upload-demo"
      drag
      :limit="1"
      :on-exceed="handleExceed"
      name="filename0"
      :file-list="fileList"
    >
      <i class="el-icon-upload" />
      <div class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>，大小不能超过 100MB
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: "umAttachment",
  data() {
    return {
      file: [],
      fileList: [],
    };
  },
  props: ["submitStatus"],
  watch: {
    submitStatus(val) {
      if (val) {
        if (this.file.length > 0) {
          var formData = new FormData(); //  用FormData存放上传文件
          this.file.forEach((file, index) => {
            formData.append("filename" + index, file.raw); //此处一定是append file.raw 上传文件只需维护fileList file.raw.name要加上
          });
          $UMCore
            .post(window.fileurl, formData)
            .then(res => {
              this.$emit("submit-file", res.data);
            })
            .catch(error => {
              this.$message.error("上传失败！");
              return false;
            });
        }else{
          this.$emit("submit-file", '');
        }
      }
    }
  },
  methods: {
    onChange(file, fileList) {
      //这里做一些文件控制，注意：就算一次选取多个文件，这里依旧会执行多次
      if(file.size/1024/1024>100){
        this.$message.error("文件上传不能超过100M！");
        this.fileList=[]
      }else{
        this.file = Object.assign(this.file, fileList);
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    success(res) {
      this.file.push(res[0].filename);
      this.$emit("getfileSrc", this.file);
      this.$emit("getfileInfo", res);
    },
    error(res) {
      this.$message.error("文件上传失败！");
      this.$emit("getfileInfo", []);
    },
    remove(res) {
      // this.file.forEach((element, index) => {
      //   if (element === res.filename) {
      //     this.file.splice(index, 1);
      //   }
      // });
      this.fileList=[]
      this.file=[]
      this.$emit("getfileInfo", []);
    }
  }
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/packages/attachment/um-attachment.vue